import { render, staticRenderFns } from "./PagesFeaturedCategoriesWidget.vue?vue&type=template&id=341e83b8&"
import script from "./PagesFeaturedCategoriesWidget.vue?vue&type=script&lang=js&"
export * from "./PagesFeaturedCategoriesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports